import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: '/',
    name: 'admin',
    meta: { title: '管理控制台', login: false, componentName: 'PcBase' },
    component: () => import('@/views/pc/PcBase.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录', login: false, componentName: 'AdminLogin' },
    component: () => import('@/views/pc/AdminLogin.vue'),
    props: true
  },
  // {
  //   path: '/test',
  //   name: 'test',
  //   meta: { title: '测试', login: false },
  //   component: () => import('@/views/pc/test/TestPage.vue')
  // }
] as RouteRecordRaw[]
